import { render, staticRenderFns } from "./MaterialFile.vue?vue&type=template&id=353b4bbc"
import script from "./MaterialFile.vue?vue&type=script&lang=js"
export * from "./MaterialFile.vue?vue&type=script&lang=js"
import style0 from "./MaterialFile.vue?vue&type=style&index=0&id=353b4bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports